import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ConsultationSubjectsDataTable {
  constructor() {
    $(document).ready(function() {
      showConsultationSubjectsTable();
    });

    $(document).on("turbo:render", function() {
      showConsultationSubjectsTable();
    });

    function showConsultationSubjectsTable() {
      $('#consultation-subjects-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#consultation-subjects-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
